import { http } from './http';
const VMA = '//vma.mediosregionales.cl'
const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get('username');

export const auth = {
    async getStatus() {
        let status = 'is-guest'
            try {
                const { data } = await http.post(`${VMA}/validacion/cookie`, { c: myParam })
                if (data.status === 'Usuario cacheado') {
                   return status = 'is-logged'
                }
            // eslint-disable-next-line no-empty
            } catch (error) { }
        return status
    },

    async init() {
        let status = await this.getStatus()
        if (status === 'is-guest') {
            window.location.href = `http://${window.location.host}`
        }
    },
}
